import React from "react";
import { formatPercent, getPerformanceColor } from "../utils/formatters";

/**
 * ColoredPercent - Displays a percentage value with color coding
 * - var(--color-positive) for positive values (theme-aware)
 * - var(--color-negative) for negative values (theme-aware)
 * - var(--stat-label-color) for zero (theme-aware)
 */
const ColoredPercent = ({ value, className = "" }) => {
  const color = getPerformanceColor(value);

  return (
    <span style={{ color }} className={className}>
      {`${value > 0 ? "+" : ""}${formatPercent(value)}`}
    </span>
  );
};

export default ColoredPercent;
